import { Injectable } from '@angular/core';

/* =============================================================================
   InitialsStateService — forked from dateless-state.service.ts (build pack
   §3.4) with an initials-specific typed snapshot. Preserves transient
   register state across a plate-detail round trip; never written to the URL
   (only the initials live there).
   ========================================================================== */

export type InitialsFormatKey = 'dlf' | 'dnf' | 'cur' | 'pre' | 'suf';
export type InitialsSortKey = 'price-asc' | 'price-desc' | 'reg-az';
export type InitialsStatusFilter = 'all' | 'available' | 'unadvertised';

export interface InitialsSnapshot {
  initials: string;                 // applied initials, e.g. "HS"
  format: InitialsFormatKey;        // selected explorer bucket
  statusFilter: InitialsStatusFilter;
  sort: InitialsSortKey;
  page: number;
  scrollY: number;
  savedAt: number;
}

const FRESH_MS = 30 * 60 * 1000; // 30 minutes, the register convention

@Injectable({ providedIn: 'root' })
export class InitialsStateService {
  private snapshot: InitialsSnapshot | null = null;

  public save(snapshot: Omit<InitialsSnapshot, 'savedAt'>): void {
    this.snapshot = { ...snapshot, savedAt: Date.now() };
  }

  /** Returns and clears the snapshot if saved within the freshness window. */
  public takeFresh(maxAgeMs: number = FRESH_MS): InitialsSnapshot | null {
    const snap = this.snapshot;
    this.snapshot = null;
    if (!snap) return null;
    return Date.now() - snap.savedAt <= maxAgeMs ? snap : null;
  }
}
